'use client';
import { getUrlByPageType } from '@fm-nx/navigation';
import { Icon } from '@fm-nx/svg';
import { useEffect, useMemo, useState } from 'react';

export interface SharePageProps {
    slug?: string | null;
    pageType?: string;
    title?: string | null;
    summary?: string | null;
}

export function SharePage(props: SharePageProps) {
    const { slug, pageType, title, summary } = props;

    const link = useMemo(() => {
        if (typeof window === 'undefined') return null;
        return window.location.href;
    }, []);

    const tweetText = useMemo(() => {
        if (!title || !slug || !pageType) return '';
        const txt = [`${title}.`];
        if (summary) {
            txt.push(summary);
        }
        const link = getUrlByPageType({ slug, pageType });
        txt.push(link.href);
        return txt.join(' ');
    }, [slug, pageType, title, summary]);

    // https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.viget.com%2Farticles%2Ftake-a-pass-at-collaborative-estimations%2F
    // http://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.viget.com%2Farticles%2Ftake-a-pass-at-collaborative-estimations%2F

    return (
        <div>
            <ul className="flex space-x-4">
                <li>
                    <a className="group" href={encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${link}`)}>
                        <Icon name="facebook" />
                    </a>
                </li>
                <li>
                    <a
                        className="group"
                        href={encodeURI(`https://www.linkedin.com/shareArticle?mini=true&url=${link}`)}
                    >
                        <Icon name="linkedin" />
                    </a>
                </li>
                <li>
                    <a className="ml-2 group" href={encodeURI(`https://twitter.com/intent/tweet?${tweetText}`)}>
                        <Icon name="twitter" />
                    </a>
                </li>
            </ul>
        </div>
    );
}

export default SharePage;
